import VideoPlayer from './VideoPlayer'

export default class YoutubeVideo extends VideoPlayer {
  constructor (elem, APP) {
    super(elem, APP)
    this.iframeURL = 'https://www.youtube.com/embed/' + this.videoID + '?autoplay=1&enablejsapi=1'
  }
  init () {
    super.init()
  }
}
